import { css } from "@emotion/react"
import { below, above } from "@mkt/cp/src/styles/Breakpoints"
import { colorsCP } from "@mkt/cp/src/styles/Tokens"

export const cta = css`
  display: flex;

  ${below["m"]} {
    flex-direction: column;
    align-items: center;
  }
`
export const input = css`
  width: 100%;

  ${above["m"]} {
    width: 350px;
    margin-right: 24px;
  }
  
  .iq-input-field__input {
    font-size: 16px;
    font-family: 'Source Sans Pro', sans-serif;
  }
`
export const button = css`
  width: 100%;

  ${above["m"]} {
    max-width: 240px;
    margin-top: 8px;
  }
`
